import React from 'react';
import InlineMath from '@matejmazur/react-katex';
import 'katex/dist/katex.min.css';

const latexElement = (math?: string) => {
    if (math) {
        if (math === '‰') math = '\\mathrlap{\\it{/}}{^0}_{\\,00}'; //Supports per-mille notation (per thousand i.e. percent/10)
        return (
            <span className='latex-wrapper'>
                <InlineMath math={math} errorColor={'#000'} />
            </span>
        );
    }
    return null;
};

export default latexElement;
